// import styles from "./AddSupportingDocumentsModalPage.module.css";
import { SupportingDocumentsSubmittedModalPage } from "../supportingDocuments/SupportingDocumentsSubmittedModalPage.tsx";
// import { useAddSupportingDocumentsModal } from "@/features/protest/viewModal/addSupportingDocumentsViewmodal";
// import { Modal } from "@/shared/modal";

type PropertyType = "RESIDENTIAL" | "COMMERCIAL" | null;

type AddSupportingDocumentsModalPageProps = {
  isOpen: boolean;
  propertyType: PropertyType;
  selectedPropertyId: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const AddSupportingDocumentsModalPage = ({
  isOpen,
  propertyType,
  onCancel,
  onConfirm,
}: AddSupportingDocumentsModalPageProps) => {
  // Skipped per current protest flow requirement. Keeping previous modal logic commented
  // so the step can be restored without changing the parent modal sequence.
  // const {
  //   visible,
  //   modalTitle,
  //   existingCount,
  //   selectedProtestId,
  //   setSelectedProtestId,
  //   protestOptions,
  //   isSubmittedModalOpen,
  //   onOpenSubmittedModal,
  //   onCloseSubmittedModal,
  // } = useAddSupportingDocumentsModal({
  //   isOpen,
  //   selectedPropertyId,
  //   onCancel,
  // });
  //
  // if (!visible) return null;

  return (
    <>
      {/*
      <Modal
        isOpen={visible}
        onClose={onCancel}
        title={modalTitle}
        titleClassName={styles.title}
        unconstrained
        className={styles.modal}
        bodyClassName={styles.addDocsModalBody}
        closeOnBackdropClick={false}
        ariaLabel={modalTitle}
      >
        <div className={styles.subtitle}>
          You have {existingCount} existing{" "}
          {propertyType === "COMMERCIAL" ? "commercial" : "residential"} protest for this property.
          Select which protest you&apos;d like to add these documents as supporting evidence.
        </div>

        <div className={styles.sectionLabel}>Select existing protest to add documents to:</div>

        <select
          className={styles.select}
          value={selectedProtestId}
          onChange={(e) => setSelectedProtestId(e.target.value)}
          aria-label="Select protest"
        >
          {protestOptions.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>

        <div className={styles.actions}>
          <button type="button" className={styles.primaryBtn} onClick={onOpenSubmittedModal}>
            Add Supporting Documents
          </button>

          <button type="button" className={styles.secondaryBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </Modal>
      */}

      <SupportingDocumentsSubmittedModalPage
        isOpen={isOpen}
        onClose={onCancel}
        onContinue={onConfirm}
        propertyType={propertyType}
      />
    </>
  );
};
